import React, { useState } from 'react';
import './Stores.css';
import locationImage from '../assets/Recursos Graficos/location.png';

const Stores = () => {
  const [expandedCity, setExpandedCity] = useState(null);

  const cities = [
    'Valencia',
    'Maracay',
    'Caracas - Catia',
    'Caracas - La Florida',
    'Barquisimeto'
  ];

  const storeInfo = {
    'Valencia': {
      address: 'C.C Brisas del Valle, nivel terrazas, Remanso, San Diego, Valencia',
      hours: 'De lunes a domingo de 12:00 pm a 10:00 pm'
    },
    'Maracay': {
      address: 'C.C Las Américas, nivel feria, Av. Las Delicias, Maracay',
      hours: 'De lunes a domingo de 12:00 pm a 10:00 pm'
    },
    'Caracas - Catia': {
      address: '2da avenida, cruce con calle Ecuador, Catia, Caracas',
      hours: 'De lunes a domingo de 12:00 pm a 10:00 pm'
    },
    'Caracas - La Florida': {
      address: 'Av. Los Jardines, diagonal a residencias Florida Suites, La Florida, Caracas',
      hours: 'De lunes a domingo de 12:00 pm a 10:00 pm'
    },
    'Barquisimeto': {
      address: 'C.C Sambil, nivel terrazas, Barquisimeto',
      hours: 'De lunes a domingo de 12:00 pm a 10:00 pm'
    }
  };

  const toggleCity = (city) => {
    setExpandedCity(expandedCity === city ? null : city);
  };

  return (
    <section className="stores" id="stores">
      <div className="container">
        <h2 className="section-title">¡Nuestras Tiendas!</h2>
      </div>
      <div className="container d-flex">
        {/* <h2 className="section-title">¡Nuestras Tiendas!</h2> */}
        <div className="stores-map">
          <img 
            src={locationImage} 
            alt="Store Locations Map"
            className="map-image"
          />
        </div>
        <div className="stores-list">
          {cities.map((city) => (
            <div key={city} className="store-item">
              <button 
                className="store-header"
                onClick={() => toggleCity(city)}
              >
                <span className="store-city">{city}</span>
                <span className={`store-toggle ${expandedCity === city ? 'expanded' : ''}`}>
                  +
                </span>
              </button>
              {expandedCity === city && (
                <div className="store-details">
                  <p><strong>Dirección:</strong> {storeInfo[city].address}</p>
                  <p><strong>Horarios:</strong> {storeInfo[city].hours}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stores;

